import { getCommonFilterConfig } from '@bingads-webui-campaign/common-grid-config';

export function getFilterConfig({
  entitySchema,
  i18n,
  sessionStore,
  preferenceStoreFactory,
  legacyGlobalI18n,
  schemaI18nCampaign,
  cacheService,
  dataContextManager,
  preferenceService,
  appConfig,
  jsData,
}) {
  const filterConfig = getCommonFilterConfig({
    preferenceService,
    featureName: 'AllSettingsGrid',
    entitySchema,
    i18n,
    legacyGlobalI18n,
    sessionStore,
    preferenceStoreFactory,
    globalConfig: appConfig,
    schemaI18nCampaign,
    cacheService,
    dataContextManager,
    jsdata: jsData,
    enableCampaignWaterfall: true,
    enableAdGroupWaterfall: false,
    editor: {},
    selector: {
      items: [
        {
          key: 'all',
          text: i18n.getString('Dashboard_AllCampaigns'),
          value: {
            query: null, // {}
          },
        },
        {
          key: 'active',
          text: i18n.getString('Dashboard_AllEnabledCampaigns'),
          value: {
            query: {
              Status: {
                $in: [
                  'Enum.CampaignStatus\'Active\'',
                  'Enum.CampaignStatus\'BudgetPaused\'',
                ],
              },
            },
          },
        },
      ],
    },
  });

  return filterConfig;
}
